import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
var getNewTimeZone = function () {
    var optionState = getRegionalOptions();
    var UserOptions = getUserConfiguration().UserOptions;
    return optionState.selectedTimeZone || UserOptions.TimeZone;
};
export default getNewTimeZone;
//# sourceMappingURL=getNewTimeZone.js.map